import axios, { AxiosResponse } from 'axios';

import { TsType } from '../types/common/CommonType';
import { RequestHeaders } from '../types/common/HeaderTypes';
import { ContactInputType } from '../types/common/ContactType';
import { CustomerInformationInputType } from '../types/common/CustomerInformationType';
import { InquiryApiRequest, InquiryApiResponse, INQUIRY_API_ERRORS } from '../types/api/InquiryApiType';
import { STARTUP_API_ERRORS } from '../types/api/StartApiType';
import { AppDispatch } from '../store/store';

import { initializeApp } from './init';
import { ConfirmationLogic } from '../pages/Confirmation/ConfirmationLogic';

// 問い合わせ登録　API-4001
const inquiryImplementation = async (
    screenTransition: TsType,
    cIInput: CustomerInformationInputType,
    contactInput: ContactInputType,
    inquiryEstimateId: string,
    dispatch: AppDispatch,
    clientId: string
) => {
    // 初期API判定
    if (clientId === '' || clientId === undefined) {
        const initApiResult = await initializeApp(dispatch, clientId);
        if (initApiResult.includes(STARTUP_API_ERRORS.REQUEST_ERROR_8001)) {
            // initApiResultが異常終了した場合
            return initApiResult;
        }
    }

    // 問い合わせデータの編集
    const saveInquiryData: InquiryApiRequest = ConfirmationLogic.editInquiry(
        screenTransition,
        cIInput,
        contactInput,
        inquiryEstimateId
    );
    // リクエストヘッダ設定
    const headers: RequestHeaders = {
        'client-id': clientId,
    };
    try {
        const result: AxiosResponse<InquiryApiResponse> = await axios.post('/api/inquiry', saveInquiryData, {
            headers: headers,
        });

        if (result.data) {
            return result.data.receipt_number;
        } else {
            // レスポンスにデータなし
            return INQUIRY_API_ERRORS.REQUEST_ERROR_4001;
        }
    } catch (error) {
        // リクエストが異常終了
        let error_ret = INQUIRY_API_ERRORS.REQUEST_ERROR_4001;
        if (axios.isAxiosError(error)) {
            if (error.response?.status) {
                // ステータスコードが設定されていた場合、ステータスコードを設定
                error_ret = INQUIRY_API_ERRORS.REQUEST_ERROR_4001_STATUS_CODE.replace(
                    '%1',
                    error.response.status as unknown as string
                );
            }
        }

        return error_ret;
    }
};

// リキャプチャ API-4002
const sendRecaptcha = async (token: string) => {
    try {
        const result: AxiosResponse<{ is_bot: boolean }> = await axios.post('/api/inquiry/recaptcha', { token: token });
        if (result.data) {
            return result.data.is_bot;
        } else {
            return INQUIRY_API_ERRORS.REQUEST_ERROR_4002;
        }
    } catch (error) {
        // リクエストが異常終了
        let error_ret = INQUIRY_API_ERRORS.REQUEST_ERROR_4002;
        if (axios.isAxiosError(error)) {
            if (error.response?.status) {
                // ステータスコードが設定されていた場合、ステータスコードを設定
                error_ret = INQUIRY_API_ERRORS.REQUEST_ERROR_4002_STATUS_CODE.replace(
                    '%1',
                    error.response.status as unknown as string
                );
            }
        }

        return error_ret;
    }
};

export const inquiryApi = {
    inquiryImplementation,
    sendRecaptcha,
};
